import { connect } from 'react-redux';
import {
  currentIterationSelector,
  getLatestIterationSelector,
  iterationsPickerSelector
} from 'state/selectors/iterations-picker';

import {
  isVPModeSelector,
  selectedTeamSelector
} from 'state/selectors/ui-state';
import {
  isTeamLicenseSelector,
  licenseSelector
} from 'state/selectors/license';
import {
  getTeams,
  toggleModal,
  toggleSnackBar,
  updateTeam,
  updateTeamContributors,
  getContributors
} from 'state/callers';
import { contributorsSelector } from 'state/selectors/contributors';
import { gitIntegrationsSelector } from 'state/selectors/sensors-authorizations';
import Individuals from './Individuals';
import withErrorBoundary from 'components/HOC/ErrorBoundryHOC';
import { teamsWithExtraSyncedDataSelector } from 'state/selectors/teams';

const mapStateToProps = state => {
  const { uiState } = state;

  return {
    uiState,
    contributors: contributorsSelector(state),
    currentTeams: teamsWithExtraSyncedDataSelector(state),
    iterationsPickerData: iterationsPickerSelector(state),
    latestIteration: getLatestIterationSelector(state),
    currentIteration: currentIterationSelector(state),
    isVPMode: isVPModeSelector(state),
    selectedTeam: selectedTeamSelector(state),
    isTeamLicense: isTeamLicenseSelector(state),
    gitIntegrations: gitIntegrationsSelector(state),
    license: licenseSelector(state)
  };
};
const mapDispatchToProps = {
  toggleModal,
  toggleSnackBar,
  updateTeam,
  updateTeamContributors,
  getTeams,
  getContributors
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withErrorBoundary(Individuals, 'Individuals'));
